import { render, staticRenderFns } from "./IconDesc.vue?vue&type=template&id=d5db4c34&scoped=true&"
import script from "./IconDesc.vue?vue&type=script&lang=js&"
export * from "./IconDesc.vue?vue&type=script&lang=js&"
import style0 from "./IconDesc.vue?vue&type=style&index=0&id=d5db4c34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5db4c34",
  null
  
)

export default component.exports